import axios from "axios";
import { MessageBox, Message } from "element-ui";
// import { showLoading, hideLoading } from '@/utils/loading';
import store from "@/store";
import { getToken, logoutClear } from "@/utils/auth";
// import { resetRouter } from '@/router'
import router from "@/router";

/** token 失效时去登录页，并带上 redirectUrl 便于登录后回到原页面 */
function goLogin() {
  const path = router.currentRoute.fullPath;
  if (path === "/login" || path.startsWith("/login?")) {
    router.push("/login");
    return;
  }
  router.push({ path: "/login", query: { redirectUrl: path } });
}

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  // timeout: 60000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // showLoading();
    // do something before request is sent
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    if (getToken() != null && getToken() != undefined && getToken() != "") {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers["Authorization"] = getToken();
    }
    return config;
  },
  (error) => {
    // hideLoading();
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    // hideLoading();
    // console.log(response);
    const res = response.data;

    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 1) {
      // Message({
      //   message: res.message || "Error",
      //   type: "error",
      //   duration: 5 * 1000,
      // });
      if (res.code == -1) {
        Message({
          message: "请登录",
          type: "error",
          duration: 5 * 1000,
        });
        logoutClear();
        goLogin();
      }
      else if (res.code == -401) {
        Message({
          message: "请登录",
          type: "error",
          duration: 5 * 1000,
        });
        logoutClear();
        goLogin();
      }
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      else if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm(
          "You have been logged out, you can cancel to stay on this page, or log in again",
          "Confirm logout",
          {
            confirmButtonText: "Re-Login",
            cancelButtonText: "Cancel",
            type: "warning",
          }
        ).then(() => {
          store.dispatch("login/resetToken").then(() => {
            location.reload();
          });
        });
      } else {
        Message({
          message: res.msg || "Error",
          type: "error",
          duration: 5 * 1000,
        });
      }
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      return res;
    }
  },
  (error) => {
    // hideLoading();
    // console.log(router); // for debug
    // console.log("err" + error); // for debug
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 返回 401 清除token信息并跳转到登录页面
          Message({
            message: error.response.data.message,
            type: "error",
            duration: 5 * 1000,
          });
          logoutClear();
          goLogin();
          break;
        default:
          Message({
            message: error.response.data.message,
            type: "error",
            duration: 5 * 1000,
          });
      }
    } else {
      Message({
        message: "登录过期",
        type: "error",
        duration: 5 * 1000,
      });
      logoutClear();
      goLogin();
    }
    return Promise.reject(error);
  }
);

export default service;
